(function(){
  var dlg = document.getElementById('cpSearch');
  if(!dlg) return;
  var input = document.getElementById('cpSearchQ');
  var res   = document.getElementById('cpSearchRes');
  var foot  = document.getElementById('cpSearchFoot');
  if(!input || !res) return;
  dlg.classList.add('nks');

  var LAB = {'Maillots de football':'Maillot','Crampons':'Crampons','Survêtements':'Survêtement','Kit enfant football':'Kit enfant','Sandales':'Sandales'};
  var POP = [['Mercurial','mercurial'],['Phantom','phantom'],['Predator','predator'],['F50','f50'],['Tiempo','tiempo'],['PSG','psg'],['Real Madrid','real madrid'],['Maroc','maroc'],['Algérie','algerie'],['Survêtement','survetement']];
  var NEW = [['crampons-nike-air-zoom-mercurial-superfly-11-elite-fg-sam-kerr-vert-glow-fuchsia-bleu-lagon',0],['crampons-mizuno-morelia-neo-5-beta-elite-fg-serene-spark-bleu-bleu-ciel-orange',2],['crampons-adidas-copa-pure-4-elite-fg-final-rush-vert-menthe-clair-noir-blanc',1],['crampons-adidas-predator-26-elite-fg-final-rush-noir-argente-vert-menthe',1]];
  input.setAttribute('placeholder','Rechercher');

  var timer=null, last=null, ctrl=null, idx=-1, newDone=false;

  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function eur(v){
    if(v===null||v===undefined||v==='')return '';
    var s=String(v).trim().replace(/[^\d.,-]/g,'');var dec=s.indexOf('.')>-1||s.indexOf(',')>-1;var n=parseFloat(s.replace(',','.'));
    if(isNaN(n))return '';if(!dec)n=n/100;
    return (n%1?n.toFixed(2).replace('.',','):String(n))+' €';
  }
  function src(u){u=String(u||'').split('?')[0];if(u.indexOf('//')===0)u='https:'+u;return u}
  function short(t){return String(t||'').replace(/^Crampons\s+/i,'').replace(/\s+ÉDITION LIMITÉE/i,'')}

  /* Detourage : fond uni retire, recadre, pointe a droite (comme le hero) */
  var CACHE={};
  function cut(u,cb){if(CACHE[u]){CACHE[u].d?cb(CACHE[u].d):CACHE[u].q.push(cb);return}CACHE[u]={q:[cb]};var im=new Image();im.crossOrigin='anonymous';
    function done(out){CACHE[u].d=out;CACHE[u].q.forEach(function(f){f(out)})}
    im.onload=function(){var out;try{var W=Math.min(480,im.naturalWidth),H=Math.round(im.naturalHeight*W/im.naturalWidth),c=document.createElement('canvas');c.width=W;c.height=H;var x=c.getContext('2d');x.fillStyle='#fff';x.fillRect(0,0,W,H);x.drawImage(im,0,0,W,H);x.fillRect(Math.round(W*.85),Math.round(H*.85),W,H);var d=x.getImageData(0,0,W,H),p=d.data,N=W*H;
      var bs=[];for(var q=0;q<W;q+=3){bs.push(q,(H-1)*W+q)}for(q=0;q<H;q+=3){bs.push(q*W,q*W+W-1)}
      var md=[0,1,2].map(function(ch){var a=bs.map(function(k){return p[k*4+ch]}).sort(function(a,b){return a-b});return a[a.length>>1]});
      var dist=function(k){var i=k*4;return Math.max(Math.abs(p[i]-md[0]),Math.abs(p[i+1]-md[1]),Math.abs(p[i+2]-md[2]))};
      var seen=new Uint8Array(N),st=new Int32Array(N),sp=0;function push(k){if(seen[k])return;if(dist(k)>14)return;seen[k]=1;st[sp++]=k}
      for(var a=0;a<W;a++){push(a);push((H-1)*W+a)}for(var b=0;b<H;b++){push(b*W);push(b*W+W-1)}
      while(sp){var k=st[--sp],cx=k%W;if(cx>0)push(k-1);if(cx<W-1)push(k+1);if(k>=W)push(k-W);if(k<N-W)push(k+W)}
      var x0=W,y0=H,x1=0,y1=0;for(k=0;k<N;k++){var i=k*4;if(seen[k]){p[i+3]=0}else{var cx=k%W,cy=(k/W)|0;
        var nb=(cx>0&&seen[k-1])||(cx<W-1&&seen[k+1])||(k>=W&&seen[k-W])||(k<N-W&&seen[k+W]);if(nb){p[i+3]=Math.min(255,Math.round(dist(k)/40*255))}
        if(cx<x0)x0=cx;if(cx>x1)x1=cx;if(cy<y0)y0=cy;if(cy>y1)y1=cy}}
      x.putImageData(d,0,0);if(x1<=x0)throw 0;
      var w=x1-x0+1,h=y1-y0+1,o=document.createElement('canvas');o.width=w;o.height=h;var y=o.getContext('2d');
      var t=x.getImageData(0,0,W,Math.max(2,y0+Math.round(h*.14))).data,sx=0,n=0;for(var j=y0*W*4+3;j<t.length;j+=4){if(t[j]>40){sx+=((j-3)/4)%W;n++}}
      if(n&&sx/n>x0+w/2){y.translate(w,0);y.scale(-1,1)}
      y.drawImage(c,x0,y0,w,h,0,0,w,h);out=o.toDataURL('image/png')}catch(e){out=u+'?width=480'}done(out)};
    im.onerror=function(){done(u+'?width=480')};im.src=u+'?width=480'}
  function hydrate(root){[].forEach.call(root.querySelectorAll('img[data-c]'),function(im){var u=im.getAttribute('data-c');im.removeAttribute('data-c');cut(u,function(d){im.onload=function(){im.classList.add('on')};im.src=d})})}

  function card(p){
    var im=src((p.featured_image&&p.featured_image.url)||p.image||(p.images&&p.images[0])||'');
    var t=p.type||p.product_type||'';var lab=LAB[t]||t;
    var pz=typeof p.price==='number'?eur(String(p.price)):eur(p.price);
    return '<a class="cps-row" href="'+esc(p.url||('/products/'+p.handle))+'"><span class="th">'+(im?'<img data-c="'+esc(im)+'" alt="">':'')+'</span>'+
      '<span class="tx">'+(lab?'<span class="vd">'+esc(lab)+'</span>':'')+'<span class="nm">'+esc(short(p.title))+'</span></span>'+(pz?'<span class="pz">'+pz+'</span>':'')+'</a>';
  }
  function rows(){return res.hidden?[]:res.querySelectorAll('.cps-row, .cps-all')}
  function mark(){var r=rows();for(var i=0;i<r.length;i++){r[i].classList.toggle('on',i===idx)}if(idx>-1&&r[idx]&&r[idx].scrollIntoView)r[idx].scrollIntoView({block:'nearest'})}
  function show(html){res.innerHTML=html;res.hidden=false;idx=-1;hydrate(res)}

  function render(list,q){
    if(foot)foot.hidden=true;
    if(!list.length){
      show('<p class="cps-msg">Aucun produit pour « '+esc(q)+' ».</p><a class="cps-all" href="/search?type=product&q='+encodeURIComponent(q)+'">Chercher quand même</a>');return;
    }
    show('<p class="cps-h">Produits</p><div class="cps-grid">'+list.map(card).join('')+'</div><a class="cps-all" href="/search?type=product&q='+encodeURIComponent(q)+'">Voir tous les résultats</a>');
  }
  function reset(){last=null;idx=-1;res.hidden=true;res.innerHTML='';if(foot)foot.hidden=false}

  function go(){
    var q=input.value.trim();if(q===last)return;last=q;
    if(q.length<2){reset();return}
    if(ctrl&&ctrl.abort){try{ctrl.abort()}catch(e){}}
    ctrl=window.AbortController?new AbortController():null;
    var url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
    fetch(url,ctrl?{signal:ctrl.signal}:undefined).then(function(r){if(!r.ok)throw 0;return r.json()}).then(function(d){
      var list=(((d||{}).resources||{}).results||{}).products||[];
      list=list.filter(function(p){var t=p.type||p.product_type||'';return t!=='Option maillot'&&String(p.title||'').indexOf('Option —')!==0});
      /* les modeles les plus recents d'abord */
      function gen(p){var m=String(p.title||'').match(/\b(\d{1,2})\b/);return m?+m[1]:0}
      list.sort(function(a,b){return (b.available===false?-1:0)-(a.available===false?-1:0)||gen(b)-gen(a)||(+b.id||0)-(+a.id||0)});
      render(list.slice(0,8),q);
    }).catch(function(){});
  }

  /* Haut du panneau : Annuler au lieu du gros bouton */
  var form=dlg.querySelector('form'),btn=form&&form.querySelector('button');
  if(btn){btn.type='button';btn.className='cps-x';btn.textContent='Annuler';btn.addEventListener('click',function(){dlg.close()})}

  /* Avant de taper : recherches populaires + nouveautes */
  if(foot){
    foot.innerHTML='<p class="cps-h">Recherches populaires</p><div class="cps-pop">'+POP.map(function(x){return '<a href="/search?type=product&q='+encodeURIComponent(x[1])+'" data-q="'+esc(x[1])+'">'+esc(x[0])+'</a>'}).join('')+'</div><p class="cps-h">Nouveautés</p><div class="cps-grid cps-new"></div>';
    foot.addEventListener('click',function(e){var a=e.target.closest('a[data-q]');if(!a)return;e.preventDefault();input.value=a.textContent;input.focus();go()});
  }
  function loadNew(){
    if(newDone||!foot)return;newDone=true;var g=foot.querySelector('.cps-new');
    Promise.all(NEW.map(function(h){return fetch('/products/'+h[0]+'.js').then(function(r){return r.ok?r.json():null}).then(function(p){if(p)p._i=Math.min(h[1],p.images.length-1);return p}).catch(function(){return null})})).then(function(A){
      A=A.filter(function(p){return p&&p.images&&p.images.length});
      if(!A.length){g.previousElementSibling.remove();g.remove();return}
      g.innerHTML=A.map(function(p){return card({title:p.title,handle:p.handle,url:'/products/'+p.handle,image:p.images[p._i],price:p.price,type:p.type})}).join('');hydrate(g);
    });
  }

  input.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(go,200)});
  dlg.addEventListener('keydown',function(e){
    var r=rows();
    if(e.key==='ArrowDown'||e.key==='ArrowUp'){if(!r.length)return;e.preventDefault();idx+=(e.key==='ArrowDown'?1:-1);if(idx<0)idx=r.length-1;if(idx>=r.length)idx=0;mark()}
    else if(e.key==='Enter'&&idx>-1&&r[idx]){e.preventDefault();window.location.href=r[idx].getAttribute('href')}
  });
  dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close()});
  dlg.addEventListener('close',function(){reset();input.value=''});

  var open=document.getElementById('cpSearchOpen');
  if(open)open.addEventListener('click',function(){
    if(!dlg.open)dlg.showModal();loadNew();
    setTimeout(function(){input.focus();input.select()},30);
  });
})();
